import { Box, BoxProps } from '@mui/material';

const Flex = (props: BoxProps) => <Box display="flex" {...props} />;

export default Flex;
